import {SValue} from "@/components/dto/SValue";

export class SValueImpl implements SValue {
    value: string;

    constructor(value: string){
        this.value = value;
    }
}
